export default __webpack_public_path__ + "static/jireh2-f88f93359a5e26d7a56f66e2c26137a7.jpg";